import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import NavBar from './Navbar/NavBar';
import bg from '../images/home.png';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Hero = () => {

    useEffect(() => {
        AOS.init({
            once: true,
        });

        window.scrollTo(0, 0);

        if ('scrollRestoration' in window.history) {
            window.history.scrollRestoration = 'manual';
        }
    }, []);

    return (
        <>
            <div className="hero min-h-screen flex flex-col" id='hero'>
                <div>
                    <NavBar />
                </div>
                
                <div className="m-auto px-4 md:px-12 lg:px-20 mt-16 lg:mt-2 p-2 md:p-12 h-auto overflow-visible" data-aos="zoom-in">
                    <div id='hero' className="flex flex-col-reverse lg:flex-row py-8 justify-between text-center lg:text-left">
                        {/* Content Section */}
                        <div className="lg:w-1/2 flex flex-col justify-center" data-aos="zoom-in" data-aos-delay="200">
                            <h1 className="mb-5 md:text-5xl text-3xl font-bold"style={{ color: '#005690' }}>
                                Custom automation &<br />
                                seamless integration
                            </h1>
                            <div className="text-xl font-semibold tracking-tight mb-5 text-gray-500">
                                Driving Industry 5.0 with cutting-edge automation solutions, integrating Artificial Intelligence, Software, Electronic, Mechanical, and Manufacturing technologies to boost efficiency and elevate quality.
                            </div>
                            <div className="mb-4 space-x-0 md:space-x-2 md:mb-8">
                                <Link to="/contact" className="text-white bg-blue-900 hover:bg-blue-800 inline-flex items-center justify-center w-full px-6 py-3 my-4 text-lg shadow-xl rounded-2xl sm:w-auto sm:mb-0" style={{ backgroundColor: '#005690' }}>
                                    Get in Touch
                                    <svg className="w-4 h-4 ml-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                        <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd"></path>
                                    </svg>
                                </Link>
                            </div>
                        </div>

                        {/* Image Section */}
                        <div className="flex lg:justify-center w-full lg:w-1/2" data-aos="fade-up" data-aos-delay="700">
                            <img 
                                alt="card img" 
                                className="rounded-t float-right duration-1000 w-full lg:w-4/5 max-w-[500px]" 
                                src={bg} 
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Hero;
